// RC8 · Port-day weather strip for Destination Intelligence cards.
// Renders a real Open-Meteo forecast only when one exists; otherwise the
// honest "Forecast available from <date>" note. Never invents values.

import React from "react";
import { CloudSun, CalendarClock } from "lucide-react";
import { formatCalendarDate, toCalendarDate } from "@/lib/calendarDate";

function fmt(iso) {
  if (!iso) return "";
  return formatCalendarDate(toCalendarDate(iso), "medium") || String(iso);
}

export function WeatherStrip({ entry }) {
  if (!entry || !entry.status || entry.status === "past") return null;
  if (entry.status === "forecast") {
    return (
      <div
        className="mt-3 flex w-fit items-center gap-2 rounded-full border border-[#C28E42]/30 bg-[#FBF7F0] px-3 py-1.5 text-[12.5px] text-[#0F172A]"
        data-testid="briefing-weather-forecast"
      >
        <CloudSun className="w-3.5 h-3.5 text-[#8A5E1E]" aria-hidden="true" />
        <span className="font-semibold">{fmt(entry.call_date)}</span>
        <span className="text-slate-300">·</span>
        <span>{entry.descriptor || "Forecast available"}</span>
        <span className="text-[10.5px] text-slate-400">Open-Meteo</span>
      </div>
    );
  }
  if (entry.status === "pending" && entry.available_from) {
    return (
      <div
        className="mt-3 flex w-fit items-center gap-2 text-[12.5px] text-slate-500"
        data-testid="briefing-weather-pending"
      >
        <CalendarClock className="w-3.5 h-3.5" aria-hidden="true" />
        <span>Forecast available from {fmt(entry.available_from)}</span>
      </div>
    );
  }
  return null;
}
